/* eslint-disable jsx-a11y/iframe-has-title */
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import 'bootstrap/dist/css/bootstrap.min.css';
import FeatherIcon from 'feather-icons-react';

import { API_URL } from '../../../constants/api';
import { CURRENT_YEAR } from '../../../constants';

const KaafiPayWeb = () => {
  const [company, setCompany] = useState(null);
  const [carousel, setCarousel] = useState([]);
  const [about, setAbout] = useState([]);
  const [services, setServices] = useState([]);
  const [facts, setFacts] = useState([]);

  const [contact, setContact] = useState([]);
  const [pricing, setPricing] = useState([]);
  const [events, setEvents] = useState([]);
  const [news, setNews] = useState([]);

  useEffect(() => {
    axios
      .get(`${API_URL}/api/sys/web-info`)
      .then((res) => {
        const data = res.data;
        setCompany(data.company[0]);
        setCarousel(data.carousel);
        setAbout(data.about);
        setServices(data.services);
        setFacts(data.facts);

        setContact(data.contact);
        setPricing(data.pricing);
        setEvents(data.events);
        setNews(data.news);
      })
      .catch((err) => console.error(err));
  }, []);

  if (!company) return <div className="text-center mt-5">Loading...</div>;

  return (
    <div>
      {/* Navbar */}
      <nav className="navbar navbar-expand-lg navbar-light bg-light fixed-top">
        <div className="container">
          <a className="navbar-brand" href="#home">
            <img
              src={`${API_URL}/${company.logo}`}
              alt="Logo"
              width="40"
              height="40"
              className="d-inline-block align-top me-2"
            />
            {company.name}
          </a>
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarNav"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse" id="navbarNav">
            <ul className="navbar-nav ms-auto">
              {['Home', 'Services', 'Pricing', 'About', 'Contact'].map(
                (section) => (
                  <li className="nav-item" key={section}>
                    <a className="nav-link" href={`#${section.toLowerCase()}`}>
                      {section}
                    </a>
                  </li>
                )
              )}
              {/* Apply Button with Feather Icon */}
              <li className="nav-item">
                <a
                  href="/portal/business-registration"
                  className="btn btn-primary"
                  onClick={() => (window.location.href = '#apply')}
                >
                  <FeatherIcon icon="clipboard" className="me-2" /> Apply
                </a>
              </li>
              {/* Login Button with Feather Icon */}
              {/* <li className="nav-item">
                &nbsp;&nbsp;
                <a href="/login/user-login" className="btn btn-secondary">
                  <FeatherIcon icon="user" className="me-2" /> Login
                </a>
              </li> */}
              <li className="nav-item dropdown">
                <a
                  className="btn btn-secondary dropdown-toggle"
                  href="#"
                  id="loginDropdown"
                  role="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  <FeatherIcon icon="user" className="me-2" /> Login
                </a>
                <ul className="dropdown-menu" aria-labelledby="loginDropdown">
                  <li>
                    <a className="dropdown-item" href="/login/user-login">
                      Business Login
                    </a>
                  </li>
                  <li>
                    <a className="dropdown-item" href="/login/customer-login">
                      Customer Login
                    </a>
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </div>
      </nav>

      {/* Carousel with Background */}
      <section id="home" className="pt-5">
        <div
          id="carouselExampleIndicators"
          className="carousel slide"
          data-bs-ride="carousel"
        >
          <div className="carousel-indicators">
            {carousel.map((_, index) => (
              <button
                key={index}
                type="button"
                data-bs-target="#carouselExampleIndicators"
                data-bs-slide-to={index}
                className={index === 0 ? 'active' : ''}
                aria-current={index === 0 ? 'true' : ''}
                aria-label={`Slide ${index + 1}`}
              ></button>
            ))}
          </div>
          <div className="carousel-inner">
            {carousel.map((item, index) => (
              <div
                key={index}
                className={`carousel-item ${index === 0 ? 'active' : ''}`}
                style={{
                  height: '90vh',
                  backgroundImage: `url('${API_URL}/${company.background}')`,
                  backgroundSize: 'cover',
                  backgroundPosition: 'center',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  color: '#fff',
                  textShadow: '1px 1px 3px rgba(0,0,0,0.8)',
                }}
              >
                <div className="text-center px-4">
                  <h1 className="display-4 fw-bold">{item.caption}</h1>
                </div>
              </div>
            ))}
          </div>

          <button
            className="carousel-control-prev"
            type="button"
            data-bs-target="#carouselExampleIndicators"
            data-bs-slide="prev"
          >
            <span
              className="carousel-control-prev-icon"
              aria-hidden="true"
            ></span>
          </button>
          <button
            className="carousel-control-next"
            type="button"
            data-bs-target="#carouselExampleIndicators"
            data-bs-slide="next"
          >
            <span
              className="carousel-control-next-icon"
              aria-hidden="true"
            ></span>
          </button>
        </div>
      </section>

      {/* About */}

      <section id="about" className="container py-5">
        <h2 className="text-center mb-4">About {company.name}</h2>
        <div
          className="row"
          dangerouslySetInnerHTML={{ __html: about[0]?.description }}
        />
      </section>

      {/* Services (Placeholder) */}
      <section
        id="services"
        className="py-5"
        style={{
          background: 'linear-gradient(to right, #f8f9fa, #e9ecef)',
        }}
      >
        <div className="container">
          <h2 className="text-center mb-5 fw-bold">{company.name} Features</h2>
          <div className="row g-4">
            {services.map((service) => (
              <div className="col-12 col-md-6 col-lg-4" key={service.id}>
                <div className="card h-100 shadow-sm">
                  <div className="card-body d-flex flex-column">
                    <h5 className="card-title text-primary mb-3">
                      {service.service_title}
                    </h5>
                    <ul className="list-unstyled flex-grow-1">
                      {service.service_items.split(',').map((item, index) => (
                        <li key={index} className="mb-2">
                          ✅ {item.trim()}
                        </li>
                      ))}
                    </ul>
                    <div className="mt-auto text-end">
                      <span className="badge bg-secondary">
                        {service.service_items.split(',').length} features
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Facts */}
      {/* Figures & Facts */}
      <section id="facts" className="py-5 bg-secondary text-white">
        <div className="container">
          <h2 className="text-center mb-4">Facts & Figures</h2>
          <div className="row text-center mb-4">
            {facts.map((fact, idx) => (
              <div className="col-12 col-md-3 mb-4" key={idx}>
                <div className={`card p-3 ${fact.color}`}>
                  <FeatherIcon icon={'users'} size={32} className="mb-2" />
                  <h3 className="card-title fw-bold">{fact.fact_value}</h3>
                  <h5 className="card-text fw-bold">{fact.fact_title}</h5>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Pricing */}
      <section
        id="pricing"
        className="py-5 text-center"
        style={{ backgroundColor: '#e9ecef' }}
      >
        <div className="container">
          <h2 className="text-center mb-5">Pricing Plans</h2>
          <div className="row">
            {pricing.map((plan) => (
              <div className={`mb-4 col-12 col-md-3 col-lg-3'}`} key={plan.id}>
                <div className="card h-100">
                  <div className="card-body text-center">
                    <p className="display-10 fw-bold text-danger">
                      <del>${plan.price}</del>
                    </p>

                    <p className="display-6 fw-bold">
                      <span> ${(plan.price * 0.5).toFixed(2)}</span>
                    </p>

                    <p className="text-success fw-bold">
                      ${(plan.price * 0.5).toFixed(2)} - 50% Discount for
                      first-time registration!
                    </p>
                    <h5 className="card-title d-flex justify-content-center align-items-center gap-2">
                      <FeatherIcon icon="tag" />
                      <span>{plan.plan_name}</span>
                      {plan.is_popular !== 0 && (
                        <span className="badge bg-danger">Popular</span>
                      )}
                    </h5>
                    <ul className="list-group list-group-flush my-3">
                      {plan.features.split(',').map((feature, index) => (
                        <li key={index} className="list-group-item">
                          {feature}
                        </li>
                      ))}
                    </ul>
                    <a
                      className="btn btn-primary w-100 mt-3"
                      href={`/portal/business-registration?plan_id=${plan.id}`}
                    >
                      Apply
                    </a>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Contact */}
      <section id="contact" className="p-5">
        <div className="container">
          <h2 className="text-center mb-4">Contact Us</h2>

          {/* Contact Information */}
          <p className="text-center">
            Email: {contact[0]?.email} <br />
            Phone: {contact[0]?.phone} <br />
            Address: {contact[0]?.address}
          </p>

          {/* Map Section */}
          {contact[0]?.map_url && (
            <div className="map-responsive">
              <iframe
                src={contact[0]?.map_url}
                width="100%"
                height="450"
                frameBorder="0"
                style={{ border: 0 }}
                allowFullScreen
                aria-hidden="false"
                tabIndex="0"
              ></iframe>
            </div>
          )}
        </div>
      </section>

      {/* Events */}
      {/* <section id="events" className="p-5 bg-light">
        <div className="container">
          <h2 className="text-center mb-4">Events</h2>
          <div className="row">
            {events.map((event, index) => (
              <div className="col-md-6 mb-4" key={index}>
                <div className="card">
                  <img
                    src={event.image_url}
                    className="card-img-top"
                    alt={event.title}
                  />
                  <div className="card-body">
                    <h5 className="card-title">{event.title}</h5>
                    <p className="card-text">{event.description}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section> */}

      {/* News */}
      {/* <section id="news" className="p-5">
        <div className="container">
          <h2 className="text-center mb-4">Latest News</h2>
          <div className="row">
            {news.map((item, index) => (
              <div className="col-md-6 mb-4" key={index}>
                <div className="card">
                  <img
                    src={item.image_url}
                    className="card-img-top"
                    alt={item.title}
                  />
                  <div className="card-body">
                    <h5 className="card-title">{item.title}</h5>
                    <p className="card-text">{item.content}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section> */}

      {/* Footer */}
      <footer className="text-center p-4 bg-dark text-white">
        &copy; {CURRENT_YEAR} {company.name}. All rights reserved.
      </footer>
    </div>
  );
};

export default KaafiPayWeb;
